/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ErrorResponseErrorsInner
 */
export interface ErrorResponseErrorsInner {
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseErrorsInner
     */
    field?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseErrorsInner
     */
    message?: string;
}

/**
 * Check if a given object implements the ErrorResponseErrorsInner interface.
 */
export function instanceOfErrorResponseErrorsInner(value: object): value is ErrorResponseErrorsInner {
    return true;
}

export function ErrorResponseErrorsInnerFromJSON(json: any): ErrorResponseErrorsInner {
    return ErrorResponseErrorsInnerFromJSONTyped(json, false);
}

export function ErrorResponseErrorsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErrorResponseErrorsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'field': json['field'] == null ? undefined : json['field'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function ErrorResponseErrorsInnerToJSON(json: any): ErrorResponseErrorsInner {
    return ErrorResponseErrorsInnerToJSONTyped(json, false);
}

export function ErrorResponseErrorsInnerToJSONTyped(value?: ErrorResponseErrorsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'field': value['field'],
        'message': value['message'],
    };
}

